import type { FC } from "react";

import { DownloadButton as DownloadButtonUi } from "@jti/ui/eva-components/DownloadButton";

import type { downloadButtonInputs } from "./DownloadButton.builder";

export type DownloadButtonProps = BuilderComponentProps<typeof downloadButtonInputs>;

export const DownloadButton: FC<DownloadButtonProps> = (props) => {
  return <DownloadButtonUi href={props.link} {...props} />;
};
